import { render } from "./providerContents.vue?vue&type=template&id=fbda3d50&scoped=true"
import script from "./providerContents.vue?vue&type=script&lang=js"
export * from "./providerContents.vue?vue&type=script&lang=js"

import "./providerContents.vue?vue&type=style&index=0&id=fbda3d50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbda3d50"]])

export default __exports__